import styled, { css } from 'styled-components';
import DoubleArrowSrc from 'assets/images/double-arrow-right.svg';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const ActionContent = styled.div`
  width: 100%;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  font-weight: bold;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  padding: 0 10px;
  overflow: hidden;
  height: 0;

  ${(props) =>
    props.isExpanded &&
    css`
      height: ${(p) => (p.height ? p.height : 'auto')};
    `}

  ${(props) =>
    props.shouldTransition &&
    css`
      transition: all 0.4s ease-in-out;
    `}
`;

export const ActionHeader = styled.div`
  box-sizing: border-box;
  width: 100%;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  margin: -10px 0 0 0;
  padding: 10px;
  background-color: rgb(77, 126, 169);
  color: white;
`;

export const HeaderToggleWrapper = styled.div`
  width: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px 0 0;
`;

export const HeaderToggle = styled.img`
  width: 12px;
  height: 12px;
  transition: all 0.4s ease-in-out;

  ${(props) =>
    props.isExpanded &&
    css`
      transform: rotate(90deg);
    `}
`;

HeaderToggle.defaultProps = {
  src: DoubleArrowSrc
};
